<div class="tickets-list-container">
  <div class="tickets-list">
    <miq-filters-bar
      [filters]="filters"
      (selection)="onFilterChange($event)"
      (clearFilters)="clearFilters()"
    ></miq-filters-bar>
  </div>
  <div class="header">
    <span class="section-hdr">
      {{ 'shared.total' | xTranslate }} {{ totalTickets || 0 }}
      {{ totalTickets === 1 ? ('shared.ticket' | xTranslate) : ('shared.tickets' | xTranslate) }}</span
    >
    <div class="pos-right-buttons">
      <button mat-button (click)="getHelp()" [matTooltip]="'shared.createTicket' | xTranslate" class="st-add-btn">
        <mat-icon svgIcon="add-icon" class="add-icon"></mat-icon>
        <span class="create-ticketlabel"> {{ 'shared.tickets' | xTranslate }}</span>
      </button>

      @if (!isProfile && $showDownloadBtn()) {
        <button
          mat-button
          (click)="downloadCsv()"
          [matTooltip]="'admin.serviceTickets.downloadCsv' | xTranslate"
          class="st-download-btn"
          [ngClass]="{ 'st-downloading-btn': isExporting(), 'st-disabled-btn': ticketsList?.length === 0 }"
          [disabled]="ticketsList?.length === 0"
        >
          @if (isExporting()) {
            <mat-spinner diameter="17" strokeWidth="2.5"></mat-spinner>
            <span class="create-ticketlabel">{{ 'reports.reportActionsDownloading' | xTranslate }}</span>
          } @else {
            <mat-icon svgIcon="download-icon"></mat-icon>
            <span class="create-ticketlabel">{{ 'admin.serviceTickets.downloadCsv' | xTranslate | uppercase }}</span>
          }
        </button>
      }
    </div>
  </div>
  <div class="ticketmenu-container">
    <miq-ticket-menu #menu></miq-ticket-menu>
    <p-table [columns]="displayedColumns" [value]="ticketsList">
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track $index) {
            <th scope="col" (click)="triggerSortEvent(col.field)">
              {{ col.header | xTranslate | uppercase }}
              @if (col.field === sortEvent.sortBy && col.header !== '' && col.field !== 'priority') {
                <span>
                  @if (sortEvent.sortOrder < 0) {
                    <mat-icon>arrow_drop_down</mat-icon>
                  }
                  @if (sortEvent.sortOrder > 0) {
                    <mat-icon>arrow_drop_up</mat-icon>
                  }
                </span>
              }
            </th>
          }
          @if (isProfile) {
            <th scope="col"></th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns let-index="rowIndex">
        <tr
          miq-ticket-row
          #ticketRow
          [pReorderableRow]="index"
          (dragstart)="isBeingDragged = true"
          (dragend)="dragTo(row[0].id); isBeingDragged = false"
          (contextmenu)="$event.preventDefault(); ticketRow.showRowMenu(ticketRow.element.nativeElement)"
          [pReorderableRowDisabled]="sortEvent.sortBy !== 'priority' || sortEvent.sortOrder > 0"
          [index]="index"
          [row]="row[0]"
          [sortEvent]="sortEvent"
          [isProfile]="isProfile"
          [isFolder]="row.length > 1"
          (checked)="addChecked($event)"
          [ngClass]="{ active: row[0].checked }"
          (unchecked)="removeUnchecked($event)"
          (menuClick)="onMenuClick($event)"
          (showTicketDetailEvent)="showTicketDetail($event)"
          (deleteTicketEmitter)="deleteTicket($event)"
        ></tr>
        @if (ticketRow.isExpanded) {
          @for (innerRow of row; track $index) {
            <tr
              miq-ticket-row
              [row]="innerRow"
              [sortEvent]="sortEvent"
              [isInGroup]="true"
              (showTicketDetailEvent)="showTicketDetail($event)"
            ></tr>
          }
        }
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" l10nTranslate>shared.noTicketsFound</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div>
    <miq-table-paginator
      #paginator
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 15, 20]"
      [length]="totalRows"
    ></miq-table-paginator>
  </div>
</div>
